import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-toast-messages",
  standalone: true,
  imports: [ToastModule, ButtonModule],
  templateUrl: "./toast-messages.component.html",
  styleUrl: "./toast-messages.component.scss",
})
export class ToastMessagesComponent {
  router = inject(Router);
  onReject() {}

  onConfirm() {
    this.router.navigate(["/about/feedback"]);
  }
}
